import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  GetStatusResponse, UploadFileResponse, ProcessFileRequest, ProcessFileResponse, CancelResponse,
} from '../models/mxp-bulk-payment.model';

@Injectable({ providedIn: 'root' })
export class MxpBulkPaymentService {
  private readonly url = environment.paymentUrl.replace(/\/$/, '') + '/api/mxp-bulk-payments';

  constructor(private readonly http: HttpClient) {}

  getStatus(): Observable<GetStatusResponse> {
    return this.http.get<GetStatusResponse>(this.url + '/status');
  }

  cleanFiles(): Observable<void> {
    return this.http.delete<void>(this.url + '/files');
  }

  uploadFile(file: File): Observable<UploadFileResponse> {
    const body = new FormData();
    body.append('file', file, file.name);
    return this.http.post<UploadFileResponse>(this.url + '/files', body);
  }

  processFile(request: ProcessFileRequest): Observable<ProcessFileResponse> {
    return this.http.post<ProcessFileResponse>(this.url + '/process', request);
  }

  cancel(): Observable<CancelResponse> {
    return this.http.post<CancelResponse>(this.url + '/cancel', {});
  }

  downloadQrCodes(): Observable<Blob> {
    return this.http.get(this.url + '/qr-codes', { responseType: 'blob' });
  }

  downloadQrImages(): Observable<Blob> {
    return this.http.get(this.url + '/qr-images', { responseType: 'blob' });
  }

  downloadInputTemplate(): Observable<Blob> {
    return this.http.get(this.url + '/input-template', { responseType: 'blob' });
  }
}
